import { round } from 'lodash'
import moment from 'moment'

import common from '../utils/common'
export default {
  round(value: number, radix = 2) {
    return value ? round(value, radix) : 0
  },
  numberFormatter(value: string) {
    // , seg, suffix
    return common.numberFormatter(value)
  },
  integerFormatter(value: string) {
    let tmp = value ? parseInt(value) : value
    tmp = tmp?.toString()
    // , seg, suffix
    return common.numberFormatter(tmp)
  },
  numberCommaParser(value: string) {
    return common.numberCommaParser(value)
  },
  customFormatter(value: string) {
    let tmp = value ? parseInt(value) : value
    tmp = tmp?.toString()
    return tmp ? tmp.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
  },
  floatFormatter(value: string) {
    if (!value || value === '') return ''

    if (value === '-') return '-'

    const numValue = parseFloat(value)

    if (isNaN(numValue)) return value

    const stringValue = numValue.toString()
    const isNegative = stringValue.startsWith('-')
    const absoluteValue = isNegative ? stringValue.substring(1) : stringValue

    const parts = absoluteValue.split('.')
    const integerPart = parts[0]
    const decimalPart = parts[1] ? '.' + parts[1] : ''

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return isNegative ? '-' + formattedInteger + decimalPart : formattedInteger + decimalPart
  },
  customParser(value: string) {
    return value.replace(/,/g, '')
  },
  timestampToDate(time: any, format = 'DD/MM/YYYY') {
    return moment.unix(time).format(format) || ''
  },
  roundNumberParser(num: number, offset = 1) {
    if (!num) return 0
    return round(num, offset)
  },
}
